import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { __metadata } from 'tslib';
import { waitForVariable } from '../../../@core/common/global';
import { ApiService } from '../../../@core/service/api.service';
import { SharedDataService } from '../../../@core/service/shared-data.service';
import { CoreColor } from '../../../@models/erp/compilationData';
import { CoreModel } from '../../../@models/erp/core';
import { FormListComponent } from '../../shared';
import { CoreEditorComponent } from './core.editor.component';

@Component({
    selector: 'ngx-erp-core',
    templateUrl: './core.component.html',
    styleUrls: ['./core.component.scss']
})
export class CoreComponent implements OnInit {

  @ViewChild('formList') formList: FormListComponent;

  coreColumns: any = {
    name: {
      title: 'Name',
      type: 'text',
      filter: true,
      editor: {
        type: 'custom',
        component: CoreEditorComponent,
      },
    },
    innerDiameter: {
      title: 'Inner Diameter (mm)',
      type: 'text',
      filter: true,
      editor: {
        type: 'custom',
        component: CoreEditorComponent,
      },
    },
    outerDiameter: {
      title: 'Outer Diameter (mm)',
      type: 'text',
      filter: true,
    },
    width: {
      title: 'Width (mm)',
      type: 'text',
      filter: true,
      editor: {
        type: 'custom',
        component: CoreEditorComponent,
      },
    },
    color: {
      title: 'Color',
      type: 'text',
      filter: true,
      editor: {
        type: 'custom',
        config: {
          selectText: 'Select',
          list: CoreColor.getOptions(),
        },
        component: CoreEditorComponent,
      },
      valuePrepareFunction: (cell) =>
        cell ? CoreColor.getOptions().find(f => f.value === cell).title : '',
    },
    notches: {
      title: 'Notches',
      type: 'text',
      filter: true,
    },
    coreImage: {
      title: 'Image',
      type: 'html',
      filter: false,
      valuePrepareFunction: (cell) => cell?.length ? `<img width="100" src="api/v1/${cell[0].url}" />` : '',
      editor: {
        type: 'custom',
        component: CoreEditorComponent,
      },    },
    code: {
      title: 'Code',
      type: 'text',
      filter: true,
      editable: false,
      addable: false,
      // sortDirection: 'desc',
    },

  };

  constructor(
    private api: ApiService,
    public data: SharedDataService,
    private toastrService: NbToastrService,
    private cdRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    // console.log(this.formList);
    this.data.loadCores().then(async (c) => await waitForVariable(this, 'formList') && this.formList.reload(c));
  }

  validate(event) {
    if (!event.newData.coreImage) delete event.newData.coreImage
    let valid: boolean = true;
    ['width', 'outerDiameter', 'innerDiameter'].forEach((field) => {
      if (isNaN(Number(event.newData[field])) || event.newData[field] < 0) {
        this.toastrService.danger(`[${field}] Numeric value >= 0 is required`, 'Validation Error');
        valid = false;
        return;
      }
    });

    if (valid) {
      console.log('validate', event.newData);
      this.api.saveCore(event.newData).then(() => this.data.reloadCores());
      event.confirm.resolve(event.newData);
      this.ngOnInit();
    }
  }
}
